export function generateID(): string {
    let id = Number.parseInt(localStorage.getItem('bilberry-generated-id') ?? '0');
    if (isNaN(id)) {
        id = 0;
    }
    id += 1;
    localStorage.setItem('bilberry-generated-id', id.toString());
    return id.toString();
}
